<template>
  <div>
    <div style="padding: 5px;">
      <simple-button @press="emitCreate">Create {{linkDefinition.secondarySideName}}</simple-button>
    </div>
    <data-table v-if="!loading"
        :configuration="operationsTableConfig"
        :data="operations"
        :component-id="`linked[${operationDefinition.id}][${linkDefinition.id}]`"
        @duplicate="handleDuplicate"
        @edit="handleEdit"
    />
  </div>
</template>

<script>
import DataTable from "@/components/table/DataTable";
import SimpleButton from "@/components/button/SimpleButton";

export default {
  name: "SimpleOperationsList",
  components: {SimpleButton, DataTable},
  props: {
    disableActions: Boolean,
    parentOperation: Object,
    linkDefinition: Object,
    operations: Array,
    operationDefinition: Object
  },
  data() {
    return {
      loading: true,
      operationsTableConfig: {
        enableAdd: false,
        allowEdit: false,
        selectionMode: 'single',
        columns: [
          {
            caption: "Id",
            datum: d => d.id.substr(0, 5)
          },
          {
            caption: "Name",
            datum: d => d.name
          }
        ],
        actions: [
          {
            name: "edit",
            icon: "edit",
            tooltip: "Edit operation"
          },
          {
            name: "duplicate",
            icon: "clone",
            tooltip: "Clone linked operation"
          },
          // {
          //   name: "unlink",
          //   icon: "unlink",
          //   tooltip: "Remove linked operation"
          // },
          {
            name: "remove",
            icon: "trash",
            tooltip: "Delete operation"
          }
        ]
      }
    }
  },
  methods: {
    handleDuplicate(payload) {
      this.$emit("duplicate", payload);
    },
    handleEdit(payload) {
      this.$emit("edit", payload);
    },
    emitCreate() {
      this.$emit("create");
    },
    prepareDataTableConfig() {
      const defaultVal = par => d => d.content[par.name];
      const valueLambdas = {
        STRING: defaultVal,
        ENUM: par => d => {
          let value = d.content[par.name];
          let enumOption = par.details.enumValues.find(op => op.value == value);
          if (enumOption == undefined) return value;
          else return enumOption.name;
        },
        DATE: par => d => this.$formats.formatDate(defaultVal(par)(d), false),
        DECIMAL: par => d => this.$numeral(d.content[par.name] / Math.pow(10, par.details.precision)).format('0,0.' + '0'.repeat(par.details.precision)),
        INTEGER: par => d => this.$numeral(d.content[par.name]).format('0'),
        BOOLEAN: par => d => d.content[par.name] ? this.$t("yes") : this.$t("no"),
        GEO_POINT: par => d => {
          if (!d.content[par.name]) {
            return "N/A"
          }
          return `${this.$formats.formatAmount(d.content[par.name]?.longtitude)}/${this.$formats.formatAmount(d.content[par.name]?.latitude)}`;
        },
        ENTITY_REFERENCE: par => d => {
          let ref_id = d.content[par.name];
          if (par.details.entityType == 'account') {
            let acc = this.account(ref_id) ?? "N/A";
            return acc.name
          }
          if (par.details.entityType == 'party') {
            let party = this.party(ref_id) ?? "N/A";
            return party.displayName
          }
          if (par.details.entityType == 'operation') {
            //return this.cachedOperations[ref_id] ?? "N/A"
            return "N/A";
          }
          return ref_id;
        },
        // CURRENCY: defaultVal,
        // ACCOUNT: par => d => {
        //     let acc = this.account(defaultVal(par)(d));
        //     if(acc == null) return "N/A";
        //     return acc.name
        // },
        // PARTY: par => d => {
        //     let party = this.party(defaultVal(par)(d));
        //     if(party == null) return "N/A";
        //     return party.displayName
        // },
        DYNA_MODEL: par => d => "Complex Object {...}",
        ARRAY: par => d => `${d.content[par.name].length} items`
      }

      const styleLambdas = {
        STRING: undefined,
        DATE: undefined,
        DECIMAL: d => ({'text-align': 'right'}),
        CURRENCY: undefined,
      }

      Object.keys(this.operationDefinition.model.dynaProperties).map(key => this.operationDefinition.model.dynaProperties[key]).forEach(par => {
        this.operationsTableConfig.columns.push({
          caption: par.displayName,
          datum: valueLambdas[par.details.type](par),
          style: d => ({
            ...styleLambdas[par.details.type] ?? (d)
          }),
          sortField: `content.values.${par.name}`,
          allowSort: true
        })
      })
    }
  },
  async mounted() {
    this.loading = true;
    await this.prepareDataTableConfig();
    this.loading = false;
  }
}
</script>

<style scoped>

</style>
